import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const WorkCenterSettings = () => import('./pages');

const moduleRoute = {
  path: '/work-centers/:workCenterUuid/settings',
  name: 'WorkCenterSettings',
  component: WorkCenterSettings,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.WORK_CENTER_SETTINGS,
      action: USER_ACTIONS.READ,
    },
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
